import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pay-loan-success',
  templateUrl: './pay-loan-success.component.html',
standalone:false,
  styleUrls: ['./pay-loan-success.component.scss']
})
export class PayLoanSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
